import './Footer.css';

export default function Rodape(){
    return(
        <footer>
            <p>© 2022 Óticas Vida. - Todos os direitos reservados.</p>
        </footer>
    )
}